var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, useParams } from 'react-router-dom';
import { Box, LoadingBox, translate } from '@lucidlink/uicore';
import { DEPENDENCY_KEYS, useDependency } from '#context';
import { useFilespaceById } from '#query-hooks';
import { filespaceRoutes } from '#services';
export const RestrictedFilespaceRouteGuard = ({ children, }) => {
    _react_refresh_temp_2();
    const { filespaceId = '', workspaceId = '' } = useParams();
    const restrictedFilespacePredicate = useDependency(DEPENDENCY_KEYS.RestrictedFilespacePredicate);
    const { query: { data: filespaceData, isError: isErrorFilespace, isPending: isPendingFilespace, }, } = useFilespaceById(workspaceId, filespaceId);
    if (isErrorFilespace) {
        return (_jsx(Navigate, { to: filespaceRoutes.filespaceDashboard({
                filespaceId,
                workspaceId,
            }) }));
    }
    if (isPendingFilespace) {
        return (_jsx(Box, { align: "center", isFullHeight: true, isFullWidth: true, justify: "center", children: _jsx(LoadingBox, { alt: translate('Checking filespace restriction status'), "data-testid": "checking-filespace-restriction-status", isFullHeight: true }) }));
    }
    const isRestricted = restrictedFilespacePredicate(filespaceData);
    if (!isRestricted) {
        return children;
    }
    return (_jsx(Navigate, { to: filespaceRoutes.filespaceDashboard({
            filespaceId,
            workspaceId,
        }) }));
};
_react_refresh_temp_1 = RestrictedFilespaceRouteGuard;
$RefreshReg$(_react_refresh_temp_1, "RestrictedFilespaceRouteGuard");
_react_refresh_temp_2(RestrictedFilespaceRouteGuard, "8GX2hDKjsjEWCAy6A6gWl9oNS6c=", false, () => [useParams, useDependency, useFilespaceById]);
